/* eslint-disable react/no-danger */

import React from 'react';

import './ChewingGumThinBanner.scss';

const ChewingGumThinBanner = ({ ...data }) => {
  const { heroImage, heading, link } = data;

  return (
    <section className="chewing-gum-thin-banner">
      <div className="chewing-gum-thin-banner__content">
        {heroImage && (
          <div className="chewing-gum-thin-banner__image-container">
            <img
              src={heroImage.url}
              alt="Gaviscon Chewing Gum cool mint pack with mint leaves, ice swirls and Gaviscon mascot"
            />
          </div>
        )}

        <div className="chewing-gum-thin-banner__heading">
          {heading && (
            <h3
              className="chewing-gum-thin-banner__title"
              dangerouslySetInnerHTML={{ __html: heading }}
            />
          )}
          {link && (
            <div
              className="chewing-gum-thin-banner__button"
              dangerouslySetInnerHTML={{ __html: link }}
            />
          )}
        </div>
      </div>
    </section>
  );
};

export default ChewingGumThinBanner;
